/* eslint-disable sort-imports */ // <--- need to keep this specific order
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import store from "@/store";

// ===== Modules =====
import AceModule from "./modules/ace";
import ActivityModule from "./modules/activity";
import AltCitiesModule from "./modules/alt-cities";
import ApplicationModule from "./modules/application";
import AuthModule from "./modules/auth";
import BlacklistModule from "./modules/blacklist";
import ContentPageModule from "./modules/content-page";
import DashboardModule from "./modules/dashboard";
import FacilityModule from "./modules/facility";
import FacilityFeatureModule from "./modules/feature";
import FacilityReviewsModule from "./modules/facility-reviews";
import GiftCardsModule from "./modules/gift-cards";
import GiftCardTiersModule from "./modules/gift-card-tiers";
import GlobalSettingModule from "./modules/global-setting";
import HelpCenterModule from "./modules/help-center";
import ImageModule from "./modules/image";
import LocationModule from "./modules/location";
import LandingPageModule from "./modules/landing-page";
import RedirectModule from "./modules/redirect";
import RoleModule from "./modules/role";
import SnackbarModule from "./modules/snackbar";
import SocialMediaIcons from "./modules/social-media-icons";
import StaticPageModule from "./modules/static-page";
import SurveysModule from "./modules/surveys";
import TPPClaimsModule from "./modules/tpp-claims";
import UserModule from "./modules/user";

Vue.use(Vuex);

axios.defaults.baseURL = process.env.VUE_APP_API_HOST;
axios.defaults.headers.common.Accept = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.interceptors.response.use(undefined, err => {
  if (!err || !err.response) {
    throw new Error("No response");
  }

  if (err.response.status === 401) {
    store.dispatch("logout");
  }

  if (err.response.status === 403) {
    store.dispatch("accessDenied");
  }

  return Promise.reject(err);
});

if (sessionStorage.getItem("access_token")) {
  axios.defaults.headers.common.Authorization = sessionStorage.getItem("access_token");
}

export default new Vuex.Store({
  modules: {
    ace: AceModule,
    activity: ActivityModule,
    altCities: AltCitiesModule,
    app: ApplicationModule,
    auth: AuthModule,
    blacklist: BlacklistModule,
    contentPage: ContentPageModule,
    dashboard: DashboardModule,
    facility: FacilityModule,
    facilityFeature: FacilityFeatureModule,
    facilityReviews: FacilityReviewsModule,
    giftCards: GiftCardsModule,
    giftCardTiers: GiftCardTiersModule,
    globalSetting: GlobalSettingModule,
    helpCenter: HelpCenterModule,
    image: ImageModule,
    location: LocationModule,
    landingPage: LandingPageModule,
    redirect: RedirectModule,
    role: RoleModule,
    snackbar: SnackbarModule,
    socialMediaIcons: SocialMediaIcons,
    staticPage: StaticPageModule,
    surveys: SurveysModule,
    tppClaims: TPPClaimsModule,
    user: UserModule
  }
});
